
    import { Vue, Prop, Component, Watch } from "vue-property-decorator";
    import { DepartmentStaff, DepartmentAssignment } from "@/models";
    import { namespace } from "vuex-class";
    import moment from "moment";
    import _ from 'lodash';
    import { MultiListSelect } from 'vue-search-select';
    import { useAppInsights } from '../../store/modules/AppInsights'
    import TrainingVideos from '../shared/TrainingVideos.vue';

    const schedule = namespace("schedule");
    const profile = namespace("profile");
    @Component({
        components: { MultiListSelect,TrainingVideos },
    })
    export default class DepartmentView extends Vue {

        @profile.State
        public profileData!: any;

        @schedule.State
        public departmentSchedules!: DepartmentStaff[];

        @schedule.State
        public userSchedules!: any;
        
        @profile.State
        appInsightEventData!: any;

        @Prop({ required: true }) readonly currentScheduleId!: string;

        days: Date[] = [];
        sortedDSList: DepartmentStaff[] = [];
        sortedDSListforSkills: DepartmentStaff[] = [];
        sortOrder: string = 'asc';
        sortArrow: string = 'arrow_upward';
        facilities: any = [];
        facilityDepts: any = [];
        selectedFacilityId: number = 0;
        selectedDeptId: number = 0;
        skills: any = [];
        selectedSkillId: number = 0;
        facilityName: string = '';
        departmentName: string = '';
        skillName!: string;
        lastUpdatedDate: string = '';
        selectedSkills: any = [];
        lastSelectedSkills: any = {};
        currentShceduleIndex: number = (localStorage.getItem("sIndex") == null ? 0 : Number(localStorage.getItem("sIndex")));
        selectedScheduleId: string = '';
        selectedFacilityName: string = '';
        selectedDeptName: string = '';
        selectedScheduleName: string = '';
        selectedSkillList: string = '';
        private columnToggle: boolean = false;
        private iconToggle: boolean = true;

        async created() {
            this.showScheduleDays();
            await this.getFiltersData();
            await this.getDepartmentSchedule();
            localStorage.setItem("visitedDepartmentView", "true");
        }

        @Watch('currentScheduleId', { immediate: true }) onMatchChanged() {
            this.selectedScheduleId = this.userSchedules[this.currentScheduleId].id;
            let Schedule = this.userSchedules.filter(x=> x.id == this.selectedScheduleId)[0]
            this.selectedScheduleName = this.getSchedulePeriod(this.userSchedules.indexOf(Schedule));
            this.onScheduleChange(this.selectedScheduleId);
        }
        async getFiltersData() {
            if (this.profileData != null) {
                var objPrimaryFacilityDepartment = {
                    facilityId: this.profileData.facilityId,
                    coid: this.profileData.coid,
                    facilityName: this.profileData.facilityName,
                    deptId: this.profileData.deptId,
                    deptCode: this.profileData.deptCode,
                    deptName: this.profileData.deptName,
                    effective: "",
                    expires: ""
                }
                const deptIndex = this.profileData.secondaryDepartments.findIndex(x => x.deptId == objPrimaryFacilityDepartment.deptId);
                if (deptIndex > -1) {
                    this.profileData.secondaryDepartments.splice(deptIndex, 1);
                }
                this.profileData.secondaryDepartments.push(objPrimaryFacilityDepartment);

                this.facilities = this.removeDuplicatesFromArrayByProperty(this.profileData.secondaryDepartments, 'facilityId');                
                this.selectedFacilityId = (localStorage.getItem("selFacId") == null ? this.profileData.facilityId : Number(localStorage.getItem("selFacId")));               
                this.facilityDepts = this.profileData.secondaryDepartments.filter(x => x.facilityId == this.selectedFacilityId);
                this.selectedDeptId = (localStorage.getItem("selDepId") == null ? this.profileData.deptId : Number(localStorage.getItem("selDepId")));               

                if (this.userSchedules == undefined) {
                    var payload = {
                        username: this.profileData.username,
                        index: this.currentShceduleIndex,
                    };

                    await this.$store.dispatch("schedule/getAllUserSchedules", payload);
                }

                if (this.userSchedules != undefined) {
                    this.selectedScheduleId = this.userSchedules[this.currentShceduleIndex].id;
                    let Schedule = this.userSchedules.filter(x=> x.id == this.selectedScheduleId)[0]
                    this.selectedScheduleName = this.getSchedulePeriod(this.userSchedules.indexOf(Schedule));
                }

                this.selectedFacilityName =  this.facilities.filter(x=> x.facilityId == this.selectedFacilityId)[0].facilityName;
                this.selectedDeptName = this.facilityDepts.filter(y=> y.deptId == this.selectedDeptId)[0].deptName;
            }
        }

        removeDuplicatesFromArrayByProperty = (arr, prop) => arr.reduce((accumulator, currentValue) => {
            if (!accumulator.find(obj => obj[prop] === currentValue[prop])) {
                accumulator.push(currentValue);
            }
            return accumulator;
        }, [])

        removeDuplicatesSkillsFromArrayByProperty = (arr, prop) => arr.reduce((accumulator, currentValue) => {
            if (accumulator.length == 0) {
                accumulator.push({ "id": 0, "description": "All", "skill": "All" });
            }
            if (!accumulator.find(obj => obj[prop] === currentValue[prop])) {
                accumulator.push({ "id": accumulator.length, "description": currentValue.skill, "skill": currentValue.skill });
            }
            return accumulator;
        }, [])

        async getDepartmentSchedule() {
            var payload = {
                startDate: this.userSchedules[this.currentShceduleIndex].startDate,
                endDate: this.userSchedules[this.currentShceduleIndex].endDate,
                deptId: this.selectedDeptId,
                username: this.profileData.username,
            };
        
            if(this.selectedDeptId > 0)
            {
            await this.$store
                .dispatch("schedule/getDepartmentSchedule", payload)
                .then((res: any) => {
                    this.skills = this.removeDuplicatesSkillsFromArrayByProperty(this.departmentSchedules, 'skill');
                    this.selectedSkills = localStorage.getItem("selSkills") == null ? this.skills.filter(x => x.skill == "All") : JSON.parse(localStorage.getItem("selSkills") as any);
                    this.sortedDSList = this.departmentSchedules;
                    this.sortedDSListforSkills = this.departmentSchedules;
                    this.getLastUpdatedDate();
                    this.getSortedDSData('');
                    this.sortDSListForFilteredSkills('');
                    this.selectedSkillList = Array.prototype.map.call(this.selectedSkills, function(item) { return item.description; }).join(",");
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err); // Handle errors any way you want
                    }
                });
            }
        }

        getLastUpdatedDate() {
            const today = new Date();
            const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            this.lastUpdatedDate = date + ' ' + time;
        }

        showScheduleDays() {
            this.days = [];
            var date1 = new Date(this.userSchedules[this.currentShceduleIndex].startDate);
            var date2 = new Date(this.userSchedules[this.currentShceduleIndex].endDate);
            var daysInSchedule = this.profileData.weeksInSchedule * 7;
            for (var i = 0; i < daysInSchedule; i++) {
                var d = new Date(date1);
                d.setDate(date1.getDate() + i);
                this.days.push(d);
            }
        }

        getSortedDSData(flag: string) {
            if (flag == 'clicked') {
                this.sortArrow = (this.sortOrder == 'asc' ? 'arrow_downward' : 'arrow_upward');
                this.sortOrder = (this.sortOrder == 'asc' ? 'desc' : 'asc');
                this.sortedDSList = this.sortedDSList.slice().sort((a, b) => (a.lastName as any) > (b.lastName as any) ? (this.sortOrder == 'asc' ? 1 : -1) : ((a.lastName as any) < (b.lastName as any) ? (this.sortOrder == 'asc' ? -1 : 1) : 0));
            }
            else {
                this.sortOrder = 'asc';
                this.sortArrow = 'arrow_upward';
                this.sortedDSList = this.sortedDSList.slice().sort((a, b) => (a.lastName as any) > (b.lastName as any) ? 1 : -1);
            }

            var loggedInStaff = this.sortedDSList.find(x => x.staffId == this.profileData.staffId);
            if (loggedInStaff != undefined) {
                var loggedInStaffIndex = this.sortedDSList.findIndex(x => x.staffId == this.profileData.staffId);
                this.sortedDSList.splice(loggedInStaffIndex, 1);
                this.sortedDSList.unshift(loggedInStaff);
            }
        }

        getFormattedDay(date: Date): string {
           return moment(date).format("ddd");
        }
        applyCSS(date, ds): string {                     
            let dayname= moment(date).format("ddd"); 
            let getcss = '';          
            if(dayname === 'Sun' || dayname === 'Sat')
            getcss = 'weekend_bg_color';            
            if(moment(date).format("MM/DD/yyyy") === moment(new Date()).format("MM/DD/yyyy") )
            {
              getcss = 'today_bg_color';
            }
            if(ds!=null)
            {               
                let objDeptStaff = this.sortedDSList.find(x => x.staffId == ds.staffId);
                let objDeptAssignment = objDeptStaff?.assignments.filter(x => moment(new Date(x.date)).format("MM/DD/yyyy") == moment(new Date(date)).format("MM/DD/yyyy"));
                if (objDeptAssignment != undefined) {
                    objDeptAssignment?.forEach(shift => {               
                    if(shift.isOverTime == true)
                    {
                        if(getcss == '')
                        getcss = 'overtimeshift_bg_color';
                        else
                        getcss = getcss + " " + 'overtimeshift_bg_color';                        
                    }
                    if(shift.isChargeShift == true)
                    {
                        if(getcss == '')
                        getcss = 'boldClass';
                        else
                        getcss = getcss + " " + 'boldClass';
                    }
                    });  
                }
            }
            return getcss;
        }

        getFormattedDate(date: Date): string {
            return moment(date).format("D");
        }

        showCellData(dayValue, dsObject) {           
            let shiftCode = '';           
            var objDepartmentStaff = this.sortedDSList.find(x => x.staffId == dsObject.staffId);
            var objDepartmentAssignment = objDepartmentStaff?.assignments.filter(x => moment(new Date(x.date)).format("MM/DD/yyyy") == moment(new Date(dayValue)).format("MM/DD/yyyy"));
            if (objDepartmentAssignment != undefined) {
                objDepartmentAssignment?.forEach(shift => {
                shiftCode += shift.shiftCode + '\n';               
                });               
                return  shiftCode.substring(0, shiftCode.length - 1);
            }
            else {
                return "";
            }
        }

        displayDate(date){
            return moment(new Date(date)).format("yyyy-MM-DD");
        }

        async onFacilityChange(event) {
            this.selectedFacilityId = event.target.value;
            this.facilityDepts = this.profileData.secondaryDepartments.filter(x => x.facilityId == event.target.value);
            if (this.selectedFacilityId == this.profileData.facilityId) {
                this.selectedDeptId = this.profileData.deptId;
            }
            else {
                this.selectedDeptId = this.facilityDepts[0].deptId;
            }
            localStorage.setItem("selFacId", this.selectedFacilityId.toString());
            localStorage.setItem("selDepId", this.selectedDeptId.toString());
            localStorage.removeItem("selSkills");
            this.selectedFacilityName =  this.facilities.filter(x=> x.facilityId == this.selectedFacilityId)[0].facilityName;
            this.selectedDeptName = this.facilityDepts.filter(y=> y.deptId == this.selectedDeptId)[0].deptName;
            await this.getDepartmentSchedule();
        }

        async onDepartmentChange(event) {
            this.selectedDeptId = event.target.value;
            localStorage.setItem("selDepId", this.selectedDeptId.toString());
            localStorage.removeItem("selSkills");
            this.selectedDeptName = this.facilityDepts.filter(y=> y.deptId == this.selectedDeptId)[0].deptName;
            await this.getDepartmentSchedule();
        }

        onSkillSelect(items, lastSelectItem) {            
            this.selectedSkills = lastSelectItem.skill == "All" ? items.filter(x => x.skill == "All") : items.filter(x => x.skill != "All");
            this.lastSelectedSkills = lastSelectItem;

            this.sortedDSListforSkills = this.sortedDSListforSkills.slice().sort((a, b) => (a.lastName as any) > (b.lastName as any) ? 1 : -1);

            var loggedInStaff = this.sortedDSListforSkills.find(x => x.staffId == this.profileData.staffId);
            if (loggedInStaff != undefined) {
                var loggedInStaffIndex = this.sortedDSListforSkills.findIndex(x => x.staffId == this.profileData.staffId);
                this.sortedDSListforSkills.splice(loggedInStaffIndex, 1);
                this.sortedDSListforSkills.unshift(loggedInStaff);
            }

            localStorage.setItem("selSkills", JSON.stringify(this.selectedSkills));
            this.selectedSkillList = Array.prototype.map.call(this.selectedSkills, function(item) { return item.description; }).join(",");
            this.sortDSListForFilteredSkills("skill"); 
        }

        sortDSListForFilteredSkills(flag) {
            if (this.selectedSkills.length > 0 && this.selectedSkills.find(x => x.skill == "All") == undefined) {
                var finalArray = [];
                for (var i = 0; i < this.selectedSkills.length; i++) {
                    var searchedArray = this.sortedDSListforSkills.filter(x => x.skill == this.selectedSkills[i].description);
                    if (searchedArray.length > 0) {
                        Array.prototype.push.apply(finalArray, searchedArray);
                    }
                }
                this.sortedDSList = finalArray;
                this.sortedDSList = this.sortedDSList.slice().sort((a, b) => (a.lastName as any) > (b.lastName as any) ? 1 : -1);

                var loggedInStaff1 = this.sortedDSList.find(x => x.staffId == this.profileData.staffId);
                if (loggedInStaff1 != undefined) {
                    var loggedInStaffIndex1 = this.sortedDSList.findIndex(x => x.staffId == this.profileData.staffId);
                    this.sortedDSList.splice(loggedInStaffIndex1, 1);
                    this.sortedDSList.unshift(loggedInStaff1);
                }
                this.sortOrder = 'asc';
                this.sortArrow = 'arrow_upward';
            }
            else {
                if (flag == "skill") {
                    this.sortedDSList = this.sortedDSListforSkills;
                    this.sortOrder = 'asc';
                    this.sortArrow = 'arrow_upward';
                }
            }
        }
        // deselect option
        reset() {
            this.selectedSkills = [] // reset
            this.sortedDSList = this.sortedDSListforSkills;
        }
        // select option from parent component
        selectFromParentComponent() {
            this.selectedSkills = _.unionWith(this.selectedSkills, [this.skills[0]], _.isEqual)
        }

        getSchedulePeriod(indexVal) {
            var scheduleDate = (
                moment(this.userSchedules[indexVal].startDate).format("ll") +
                " - " +
                moment(this.userSchedules[indexVal].endDate).format("ll"));
            return scheduleDate;
        }

        async onScheduleChange(value) {
            this.selectedScheduleId = value;
            var schedule = this.userSchedules.find(x => x.id == value);
            this.currentShceduleIndex = this.userSchedules.indexOf(schedule);
            localStorage.setItem("sIndex", this.currentShceduleIndex.toString());
            let Schedule = this.userSchedules.filter(x=> x.id == this.selectedScheduleId)[0]
            this.selectedScheduleName = this.getSchedulePeriod(this.userSchedules.indexOf(Schedule));
            this.showScheduleDays();
            await this.getDepartmentSchedule();
        }

        hideColumns(){
            this.columnToggle = true;
            this.iconToggle = false;
        }

        showColumns(){
            this.columnToggle = false;
            this.iconToggle = true;
        }
    }

